const AnalyticsIcon = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<g clipPath='url(#clip0_284_2123)'>
				<rect
					opacity='0.6'
					x='3'
					y='3'
					width='18'
					height='18'
					rx='2'
					stroke='#BF8AFC'
					strokeWidth='0.04'
				/>
				<rect
					opacity='0.6'
					x='2'
					y='2'
					width='20'
					height='20'
					rx='10'
					stroke='#BF8AFC'
					strokeWidth='0.04'
				/>
				<rect
					opacity='0.6'
					x='7'
					y='7'
					width='10'
					height='10'
					rx='5'
					stroke='#BF8AFC'
					strokeWidth='0.04'
				/>
				<rect
					opacity='0.6'
					x='2'
					y='4'
					width='20'
					height='16'
					rx='2'
					stroke='#BF8AFC'
					strokeWidth='0.04'
				/>
				<rect
					opacity='0.6'
					x='4'
					y='22'
					width='20'
					height='16'
					rx='2'
					transform='rotate(-90 4 22)'
					stroke='#BF8AFC'
					strokeWidth='0.04'
				/>
				<path
					opacity='0.6'
					d='M24 0L0 24'
					stroke='#BF8AFC'
					strokeWidth='0.04'
				/>
				<path
					opacity='0.6'
					d='M0 0L24 24'
					stroke='#BF8AFC'
					strokeWidth='0.04'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.5 3.75C4.91421 3.75 5.25 4.08579 5.25 4.5V18.75H19.5C19.9142 18.75 20.25 19.0858 20.25 19.5C20.25 19.9142 19.9142 20.25 19.5 20.25H4.5C4.08579 20.25 3.75 19.9142 3.75 19.5V4.5C3.75 4.08579 4.08579 3.75 4.5 3.75ZM8 14C8.55228 14 9 13.5523 9 13C9 12.4477 8.55228 12 8 12C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14ZM11.5 9C11.5 9.55228 11.0523 10 10.5 10C9.94772 10 9.5 9.55228 9.5 9C9.5 8.44772 9.94772 8 10.5 8C11.0523 8 11.5 8.44772 11.5 9ZM13 16C13.5523 16 14 15.5523 14 15C14 14.4477 13.5523 14 13 14C12.4477 14 12 14.4477 12 15C12 15.5523 12.4477 16 13 16ZM16.5 11C16.5 11.5523 16.0523 12 15.5 12C14.9477 12 14.5 11.5523 14.5 11C14.5 10.4477 14.9477 10 15.5 10C16.0523 10 16.5 10.4477 16.5 11ZM18 8C18.5523 8 19 7.55228 19 7C19 6.44772 18.5523 6 18 6C17.4477 6 17 6.44772 17 7C17 7.55228 17.4477 8 18 8Z'
					fill='#BF8AFC'
				/>
			</g>
			<defs>
				<clipPath id='clip0_284_2123'>
					<rect
						width='24'
						height='24'
						fill='white'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default AnalyticsIcon;
